// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"87":"07833052","801":"b2ed75dd"}[chunkId] + ".chunk.js";
};